export const MODAL_SIZE = {
    tiny: '440px',
    small: '580px',
    medium: '720px',
    large: '900px',
};
//# sourceMappingURL=types.js.map